/** Explicit full collection for small lookup catalogs, never for a paged table. */
export async function collectCursorPages<T>(fetchPage: (after?: string) => Promise<{ items?: T[]; meta?: { next?: string | null; exactTotal?: number | null } }>): Promise<{ items: T[]; meta: { exactTotal: number; limit: number } }> {
  const items: T[] = [];
  const seen = new Set<string>();
  let after: string | undefined;
  do {
    const page = await fetchPage(after);
    items.push(...(page.items ?? []));
    after = page.meta?.next || undefined;
    if (after && seen.has(after)) throw new Error('The server repeated a pagination cursor. Please refresh.');
    if (after) seen.add(after);
  } while (after);
  return { items, meta: { exactTotal: items.length, limit: items.length } };
}
